import React from 'react';

import HeadingBar from '../../../../components/Modules/HeadingBar';
import Feed from "../../../Feed";

const MyEvents = ({ events, ownChannels, userClaims, location }) => {
  let sortEvent = [];

  if (userClaims.userType === "Contributor" && ownChannels[0] && ownChannels[0].id) {
    sortEvent = events.filter(item => item.channel.id === ownChannels[0].id)
  } else if ( !userClaims.userType) {
    events = []
  } else if (userClaims.userType === "Admin") {
    sortEvent = events
  }

  if(events.length > 0) {
    return (
      <React.Fragment>
        <HeadingBar
          title={`My events (${sortEvent.length})`}
          // additional={viewAll}
        />

        <Feed
          list={sortEvent}
          location ={location}
          renderType={"events"}
          eventType={"all"}
          pageType={"myProfile"}
        />
      </React.Fragment>
    )
  }

  return null;
}

export default MyEvents;


// WEBPACK FOOTER //
// ./src/pages/MyProfile/InfoAndEventsTab/MyEvents/index.js